import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "prev--sprite",
  "use": "prev--sprite-usage",
  "viewBox": "0 0 105 155",
  "content": "<symbol viewBox=\"0 0 105 155\" id=\"prev--sprite\">\n<path d=\"M6.2534 72.7552L0 61.0935L98.1249 0.000488281L104.387 11.6709L6.2534 72.7552Z\" />\n<path d=\"M98.0929 155L104.387 142.776L6.29425 79.082L0 91.3156L98.0929 155Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol